var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoteltourismIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_322)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#377BFE",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6 102.711C67.0259 103.885 67.0053 105.174 66.5423 106.334C66.0793 107.494 65.2061 108.443 64.0889 109L61 110.556L52.1111 97.978L39.4444 89.0225L41 85.9114C41.55 84.7878 42.4995 83.9099 43.6627 83.4496C44.8258 82.9892 46.119 82.9796 47.2889 83.4225L54.3778 86.1114L67.2889 71.0225L73.6444 74.0447C74.7047 74.5444 75.5546 75.4021 76.0444 76.4669L79.0667 82.8225L64 95.7336L66.6 102.711Z",
    fill: "#377BFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.556 48.3334C110.554 49.5026 110.321 50.6599 109.871 51.7391C109.421 52.8182 108.763 53.798 107.933 54.6223L98.7778 63.889L98.0667 61.6667C97.3261 59.3921 96.0584 57.3247 94.3669 55.6332C92.6753 53.9417 90.608 52.674 88.3333 51.9334L86.1111 51.2001L95.2889 42.0667C96.5257 40.7926 98.1158 39.9181 99.8542 39.5559C101.593 39.1938 103.4 39.3607 105.042 40.035C106.685 40.7093 108.088 41.8601 109.071 43.3392C110.053 44.8183 110.571 46.5577 110.556 48.3334Z",
    fill: "#377BFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.667 97.5555L94.2222 102.511L80.6667 74.1778C79.6768 72.0659 77.9785 70.3676 75.8667 69.3778L47.4889 55.8222L52.4444 48.3333C53.0814 47.3828 54.0188 46.6735 55.1066 46.319C56.1944 45.9644 57.3698 45.9851 58.4444 46.3778C58.4444 46.3778 84.4889 55.9333 86.8 56.6889C88.3037 57.1836 89.6702 58.0245 90.7895 59.1438C91.9088 60.2632 92.7497 61.6297 93.2444 63.1333C93.2444 63.1333 101.667 86.6222 103.556 91.5555C103.955 92.6231 103.986 93.7934 103.643 94.8805C103.301 95.9677 102.605 96.9092 101.667 97.5555Z",
    fill: "#377BFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoteltourismIcon);
export default __webpack_public_path__ + "static/media/hotel.tourismIcon.2fc470936295c19ee1c50b41b0a09514.svg";
export { ForwardRef as ReactComponent };